module.exports = __webpack_public_path__ + "img/intro_uk.eaf378b7.svg";